<template>
  <div class="p-seed-keywords-keywords">
    <div style="max-height: 600px; overflow-y: auto;">
      <ListKeyword
        :checked="params.checked"
        :items="limitedItems"
        :period="period"
        :project="project"
        :selectedId="selectedId"
        :sort="sort"
        @check="updateChecked"
        @select="select"
        @sort="updateSort"
        @displayItem="displayItem"
      />
    </div>
    <transition name="v-fade">
      <CheckedStatus
        v-if="checkedCount"
        :count="checkedCount"
        @reset="resetChecked"
        key="check"
      />
    </transition>
    <portal to="form-add-tasks">
      <transition name="v-fade">
        <FormAddTasks
          v-if="checkedCount"
          :count="checkedCount"
          :items="checkedItems"
          :project="project"
          key="form"
        />
      </transition>
    </portal>
  </div>
</template>

<script>
import CheckedStatus from '@/components/siteKeywordAnalysis/CheckedStatus';
import FormAddTasks from '@/components/FormAddTasks';
import ListKeyword from '@/components/siteImportantKeyword/ListKeyword';

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    limitedItems: {
      type: Array,
      required: true
    },
    period: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    selectedId: {
      type: String,
      required: true
    },
    sort: {
      type: Object,
      required: true
    }
  },
  components: {
    CheckedStatus,
    FormAddTasks,
    ListKeyword
  },
  data() {
    return {
      params: {
        checked: []
      }
    };
  },
  computed: {
    checkedCount() {
      return this.checkedItems.length;
    },
    checkedItems() {
      return this.items.filter(
        item => this.params.checked.indexOf(item.id) !== -1
      );
    }
  },
  methods: {
    resetChecked() {
      this.params.checked = [];
    },
    select(item) {
      this.$emit('select', item.id);
    },
    updateChecked(checked) {
      this.params.checked = checked;
    },
    updateSort(sort) {
      this.$emit('sort', sort);
    },
    displayItem(id) {
      this.$emit('displayItem', id);
    }
  }
};
</script>
